// extracted by mini-css-extract-plugin
export default {"formSpace":"styles_formSpace__kxVu7","thead":"styles_thead__Uhuoe","table":"styles_table__L6dMc"};